import Logout from "./components/Logout/Logout";

export default Logout;
